import styled from 'styled-components'

const PendingUsersContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`

export { PendingUsersContainer }
